import script from "./Students.vue?vue&type=script&setup=true&lang=js"
export * from "./Students.vue?vue&type=script&setup=true&lang=js"

import "./Students.vue?vue&type=style&index=0&id=b13f0410&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b13f0410"]])

export default __exports__